import React, {
  ReactElement,
  useState,
  useEffect,
  useRef,
  forwardRef,
  Ref,
} from "react";
import { Popover } from "@screencloud/screencloud-ui-components";
import "./EmojiPicker.scss";

interface EmojiPickerProps {
  onEmojiPicked: (event: { value: string }) => void;
  mode?: "vertical" | "horizontal";
}

const emojis = [
  { value: "👍", label: "Yes" },
  { value: "👎", label: "No" },
  { value: "🔇", label: "Sound issues" },
  { value: "😂", label: "Laughing" },
  { value: "😍", label: "Love it" },
  { value: "👏", label: "Applause" },
  { value: "😮", label: "Surprise" },
];

const EmojiPicker = (
  props: EmojiPickerProps,
  ref: Ref<HTMLDivElement>
): ReactElement<EmojiPickerProps> => {
  const { onEmojiPicked } = props;
  const mode = props.mode || "horizontal";
  const [currentEmoji, setCurrentEmoji] = useState("");
  const [currentEmojiClass, setCurrentEmojiClass] = useState("");
  const emojiPickerRef = useRef(null);

  useEffect(() => {
    setCurrentEmojiClass("animate");
    const timeout = setTimeout(() => {
      setCurrentEmojiClass("");
      clearTimeout(timeout);
    }, 400);
  }, [currentEmoji]);

  return (
    <div ref={emojiPickerRef} className="emoji-picker-container">
      <div className={`emojis ${mode}`} ref={ref}>
        {emojis.map((emoji) => {
          return (
            <Popover
              inverted
              position="top center"
              content={emoji.label}
              key={emoji.value}
              trigger={
                <span
                  role="img"
                  className={`emoji ${
                    emoji.value === currentEmoji
                      ? "current-emoji " + currentEmojiClass
                      : ""
                  }`}
                  aria-label={emoji.label}
                  onClick={() => {
                    setCurrentEmoji(emoji.value);
                    onEmojiPicked({
                      value: emoji.value,
                    });
                  }}
                >
                  {emoji.value}
                </span>
              }
            />
          );
        })}
      </div>
    </div>
  );
};

export default forwardRef(EmojiPicker);
